export const selectPurchasesList = state => state.purchases;
